module.exports = __webpack_public_path__ + "static/media/bg.57bed498.png";